export default {
    COMPRIMENTO: 1,
    ESTATURA: 2,
}